const MEMBERS = [
  {
    id: "murad",
    name: "Murad Shahsuvarov",
    role: "Co-Founder, Director & Researcher",
    bio: "Co-founds and directs the company while contributing as an active researcher across applied mathematics, computational methods, and the translation of early-stage research into structured technical foundations.",
    tag: "Founding Team",
    photo:
      "https://customer-assets.emergentagent.com/job_noeton-compute/artifacts/jnw43hfd_Murad.jpeg",
  },
  {
    id: "reza",
    name: "Dr. Reza Shahidi",
    role: "Co-Founder, Director & Research Advisor",
    bio: "Co-founds and helps direct the company while providing academic guidance on research methodology, computational approaches, and the design of rigorous experimental and analytical frameworks supporting the company's long-term technical direction.",
    tag: "Founding Team",
    photo:
      "https://customer-assets.emergentagent.com/job_noeton-compute/artifacts/iu0djnlc_Reza.webp",
  },
];

export default function Team() {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative py-24 md:py-36 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 md:mb-20">
          <div className="flex items-center gap-3 mb-6">
            <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500">
              04 / Team
            </span>
            <span className="w-24 h-px bg-white/10" />
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tighter font-medium text-white leading-[1.02] max-w-3xl">
            Founding team.
          </h2>
          <p className="mt-6 max-w-2xl text-[15px] md:text-base text-zinc-400 font-light leading-relaxed">
            A small, research-focused group shaping the company's technical
            foundations and long-term direction.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {MEMBERS.map((m) => (
            <article
              key={m.id}
              data-testid={`team-member-${m.id}`}
              className="group bg-[#0a0a0a] hover:bg-[#111111] transition-colors p-8 md:p-12 flex flex-col"
            >
              <div className="flex items-center justify-between mb-12">
                <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500">
                  {m.tag}
                </span>
                <span className="font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-600">
                  {m.id === "murad" ? "01" : "02"}
                </span>
              </div>

              {/* Member portrait */}
              <div className="mb-10 flex items-end gap-6">
                <div className="w-24 h-24 md:w-28 md:h-28 border border-white/15 overflow-hidden bg-[#050505] group-hover:border-white/40 transition-colors">
                  <img
                    src={m.photo}
                    alt={m.name}
                    loading="lazy"
                    className="w-full h-full object-cover grayscale contrast-110 group-hover:grayscale-0 transition-all duration-500"
                  />
                </div>
                <div className="flex-1 h-px bg-white/10 mb-4" />
              </div>

              <h3 className="font-heading text-2xl md:text-3xl tracking-tight font-medium text-white leading-tight">
                {m.name}
              </h3>
              <div className="mt-2 font-mono text-[11px] tracking-[0.22em] uppercase text-zinc-400">
                {m.role}
              </div>
              <p className="mt-6 text-[15px] text-zinc-400 leading-relaxed font-light max-w-md">
                {m.bio}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
